import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { AssessmentConstants } from '../../shared/Constants';
import { intlShape } from '../prop-types';
import { getTimelineAction, getTimelineHistory, getTimelineHeader } from './TimelineComponent';

const i18n = defineMessages({
  Assessment: {
    id: 'assessment',
    defaultMessage: 'Assessment',
  },
  SurveyRespondent: {
    id: 'survey',
    defaultMessage: 'Survey',
  },
  JobProfileSurvey: {
    id: 'job_profile_survey',
    defaultMessage: 'Job Profile Survey',
  },
});

class AssessmentTimelineBox extends Component {
  constructor(props) {
    super(props);

    const { assessment } = this.props;

    this.state = {
      lastAction: assessment.status,
      isPreview: false,
    };

    this.updateLastAction = this.updateLastAction.bind(this);
    this.handlePreview = this.handlePreview.bind(this);
    this.previewJPS = this.previewJPS.bind(this);
    this.previewSurvey = this.previewSurvey.bind(this);
    this.previewAssessment = this.previewAssessment.bind(this);
  }

  updateLastAction(status) {
    this.setState({ lastAction: status });
  }

  handlePreview() {
    const { assessment } = this.props;
    if (assessment.instrument) {
      switch (assessment.instrument) {
        case AssessmentConstants.INSTRUMENT_TYPES.JPS:
          return this.previewJPS();
        case AssessmentConstants.INSTRUMENT_TYPES.STD:
          return this.previewAssessment();
        case AssessmentConstants.INSTRUMENT_TYPES.C360:
          return this.previewSurvey();
        default:
          return null;
      }
    }
    return null;
  }

  async previewJPS() {
    const { assessment } = this.props;
    window.open(assessment.startUrl, '_blank');
  }

  async previewSurvey() {
    const { assessment } = this.props;
    window.open(assessment.startUrl, '_blank');
  }

  async previewAssessment() {
    const { assessment } = this.props;
    window.open(assessment.startUrl, '_blank');
  }

  render() {
    const {
      respondent,
      assessment,
      ownerUiPreferences,
      availableTranslations,
      surveyError,
      currentAccount,
      intl: { formatMessage },
    } = this.props;
    const { lastAction, isPreview } = this.state;
    let timelineHeader = null;


    timelineHeader = getTimelineHeader(assessment, currentAccount, formatMessage);
    const asmtTypeDisplay = formatMessage(i18n[assessment.__typename]);
    return (
      <>
        <div
          className={`timeline-item ${assessment.instrument}
        ${surveyError && assessment.__typename === 'SurveyRespondent' ? 'has-error' : ''}`}
        >
          <div className="timeline-header">
            {timelineHeader}
            <span>{asmtTypeDisplay}</span>
          </div>
          <div className="timeline-body">
            <div className="vertList">
              {getTimelineHistory(assessment)[lastAction]}
              {
              getTimelineAction(
                lastAction,
                respondent,
                assessment,
                this.updateLastAction,
                assessment.instrument,
                ownerUiPreferences,
                this.handlePreview,
                isPreview,
                availableTranslations,
              )
            }
            </div>
          </div>
        </div>

        <hr />
      </>
    );
  }
}

AssessmentTimelineBox.propTypes = {
  respondent: PropTypes.objectOf(PropTypes.any).isRequired,
  assessment: PropTypes.objectOf(PropTypes.any).isRequired,
  ownerUiPreferences: PropTypes.objectOf(PropTypes.any),
  availableTranslations: PropTypes.arrayOf(PropTypes.any).isRequired,
  surveyError: PropTypes.bool.isRequired,
  currentAccount: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
};

AssessmentTimelineBox.defaultProps = {
  ownerUiPreferences: null,
};

export default injectIntl(AssessmentTimelineBox);
